<div
  #topElement
  id="cac-prequalfinal-success-div-backGround"
  class="col-md-12 divBorder"
>
  <div id="cac-prequalfinal-success-div-right" class="">
    <div class="divWhiteBackground">
      <div class="wizard logoalignment">
        <div
          role="presentation"
          class="slider-icon-disabled custom-display-inline"
        >
          <div class="left-slot">
            <a href="/">
              <img src="{{ logoURL }}" alt="" width="150" height="35px" />
            </a>
          </div>
        </div>
        <div
          class="slot custom-display-inline closeBtn-finalResponse"
          (click)="navigateToHome()"
        >
          <img
            alt="close icon"
            class="lightgrey cursorpointer closeImgSize"
            src="{{ closeURL }}"
            alt=""
          />
        </div>
      </div>

      <div id="cac-prequalfinal-success-message" class="form-group center">
        <h2 class="congrats h3-black" id="cacfinal-success-congrats-h2">
          {{ formFieldData?.title }}
        </h2>
        <br class="mobileOnly" />
        <h5 class="infotext-finalResponse h4-black">
          {{
            prequalified
              ? formFieldData?.prequalifiedSubTitle
              : formFieldData?.subTitle
          }}
        </h5>
      </div>
      <div>
        <div class="imgspacing">
          <img src="{{ congratsImg }}" alt="" width="100%" />
        </div>
        <h5 class="center infotext-final h4-black" *ngIf="!prequalified">
          {{ formFieldData?.info }}
        </h5>
        <div class="form-group center mt-12px" *ngIf="prequalified">
          <div class="congrats h4-black bold center">
            {{ formFieldData.prequalifiedContact }}<br />{{
              formFieldData.prequalifiedNext24
            }}
          </div>
        </div>
        <div class="dealer-info-container wizard desktop" *ngIf="prequalified">
          <div *ngFor="let dealer of dealers; let i = index">
            <div id="dealer{{ i }}" class="dealer-info-item">
              <div class="custom-display-inline dealer-info-align">
                <p class="form-field-black dealer-name">
                  {{ dealer?.dealerName }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.addressLine1 | titlecase }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.city | titlecase }}, {{ dealer?.state }}
                  {{ dealer?.zip }}
                </p>
                <p class="form-field-black">
                  <a
                    href="tel:{{ dealer?.phone ?? '' | phoneFormat }}"
                    class="phone-number"
                    >{{ dealer?.phone ?? '' | phoneFormat }}</a
                  >
                </p>
              </div>
              <div
                *ngIf="i !== 2"
                class="custom-display-inline dealer-info-vertical"
              >
                <hr class="dealer-info-hr-vertical" />
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="prequalified">
          <div
            *ngFor="let dealer of dealers; let i = index"
            class="formStyle mobileOnly wizard"
          >
            <div id="mobiledealer{{ i }}">
              <div class="blackColor-80">
                <p class="form-field-black dealer-name">
                  {{ dealer?.dealerName }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.addressLine1 | titlecase }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.city | titlecase }}, {{ dealer?.state }}
                  {{ dealer?.zip }}
                </p>
                <p class="form-field-black">
                  <a
                    href="tel:{{ dealer?.phone ?? '' | phoneFormat }}"
                    class="phone-number"
                    >{{ dealer?.phone ?? '' | phoneFormat }}</a
                  >
                </p>
              </div>

              <hr class="dealer-info-hr-horizontal" />
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
